import {
  ADD_LOGISTICS,
  DELETE_LOGISTICS,
  LOAD_LOGISTICS,
  SET_LOGISTICS,
} from '../actions/actionTypes';

const initialState = {
  list: [],
  loading: false,
};

const logisticsReducer = (state = initialState, action) => {
  const logistics = state.list.slice();

  switch (action.type) {
    case LOAD_LOGISTICS:
      return { ...state, loading: true };
    case SET_LOGISTICS:
      return { ...state, loading: false, list: action.logistics };
    case ADD_LOGISTICS:
      const newLogistics = {
        id: action.id,
        country: action.country,
        name: action.name,
        address: action.address,
        state: action.state,
        postCode: action.postCode,
      };

      return { ...state, list: [...logistics, newLogistics], loading: false };
    case DELETE_LOGISTICS:
      return {
        ...state,
        list: logistics.filter((item) => item.id !== action.id),
        loading: false,
      };
    default:
      return state;
  }
};

export default logisticsReducer;
